import React from 'react';
import { displayRole } from './roleLabel';

const getInitials = (name) => {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const MemberRow = ({ member, assignedHours, isFixed, partnerId }) => {
  const initials = getInitials(member.Name);
  const expected = member.Changed_Expected_Hours || member.Weekly_Expected_Hours || 0;

  return (
    <div className="grid-member">
      <div className="grid-member__avatar">{initials}</div>
      <div className="grid-member__info">
        <span className="grid-member__name" title={member.Name}>{member.Name}</span>
        <span className="grid-member__role">
          {member.Role_Name || displayRole(member.Role_Type, partnerId)}
          {isFixed && <span className="grid-member__badge">fixed</span>}
        </span>
      </div>
      <div className="grid-member__hours">
        {assignedHours !== undefined ? `${assignedHours.toFixed(0)}` : '0'}/{expected}h
      </div>
    </div>
  );
};

export default MemberRow;
